/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  pageConfig.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:28
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

/**
 * 配置颜色列表
 */
export const colorList = [
    "#FC3B3B",
    "#FC3BBC",
    "#3B4FFC",
    "#3BFCF0",
    "#55FC3B",
    "#FCF53B",
    "#FC683B",
    "#C70A0A",
    "#37C213",
    "#7D6AFC",
    "#C3A8E8",
    "#9031A5",
]

/**
 * 配置路由白名单，白名单以内的路径无需必须有token才能跳转
 */
/* 担保函路由 */
let guaranteeRouter = [
  '/fileList',
  "/guaranteeFace",
  "/guaranteeResult",
  "/guaranteeInfo",
  "/guaranteeDetail",
  '/guaranteeSuccess'
]
export const whitePathList = ['/shareGoodsDetail', '/shareGoodsList', '/shareService', '/shareRegister', '/shareLogin', '/shareGoodsListDetail', '/userAgreement', '/privacyPolicy', '/about', '/messageProtect',...guaranteeRouter]
